import React, { useContext, useEffect, useMemo } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import OrderStepFrame from '../../Components/QrOrderStep/OrderStepFrame';
// import OrderStep_1 from '../../Components/OrderStep/OrderStep_1';
// import OrderStep_2 from '../../Components/OrderStep/OrderStep_2';
import OrderStep_3 from '../../Components/OrderStep/OrderStep_3';
import OrderStep_3_mealInfo from '../../Components/OrderStep/OrderStep_3_mealInfo';
import OrderStep_4 from '../../Components/OrderStep/OrderStep_4';
import OrderStep_5 from '../../Components/OrderStep/OrderStep_5';
import OrderStep_5_verifyEmail from '../../Components/OrderStep/OrderStep_5_verifyEmail';
import { Global } from '../../App';
import moment from 'moment';
import qs from 'querystring';
import '../pages.scss';

// switch lang
import { countryCodeToCode } from '../../Share/Tools/switchLang';
// api
import { getQRCodeVerifyOrder } from '../../Api/VerifyQueue';
import { getOnlyStore } from '../../Api/GetStore'

function QrTakeOrder(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  // 檢查get參數
  const checkURL = useMemo(() => {
    const { search } = props.location;
    if (search !== '' && search !== undefined && search !== null) {
      dispatchGlobal({ type: 'RESET' });
      const par = qs.parse(search.split('?')[1]);
      return par;
    } else {
      return '';
    }
  }, [props.location.search]);

  // 驗證來店資訊
  async function apiVerifyQRCode() {
    const par = checkURL;
    try {
      const res = await getQRCodeVerifyOrder(par.guid);

      const { errCode } = res.data;
      if (res) {
        return res.data.response;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.replace('/error');
      }
    } catch (err) {
      console.error('VerifyQRCodeStatus error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 405 }]
      });
      props.history.push('/error');
    }
  }

  // 檢查是否有get參數(由QRcode進入網站)
  async function handler() {
    const par = checkURL;
    if (par) {
      // 移除query網址
      props.history.push({
        search: ''
      });

      const ckeckQrCode = await apiVerifyQRCode();
      if (ckeckQrCode.check) {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            {
              key: 'customer',
              val: {
                ...globalState.customer,
                currentQrStep: '1',
                QRCodeID: par.guid,
                orderInfo: {
                  selectedBranch: {
                    branchCode: ckeckQrCode.orderContent.store_id,
                    // branchName: storeInfo.name
                  }
                }
              }
            }
          ]
        });
        // QRCode已被使用
      } else {
        // 已有訂單
        if (ckeckQrCode.orderContent) {
          const { order_code, store_id, create_at } = ckeckQrCode.orderContent;
          props.history.push(`/showOrderDetail?orderCode=${order_code}&storeID=${String(store_id)}&createAt=${create_at}`);
        } else {
          // 查無guid
          dispatchGlobal({
            type: 'UPDATE',
            payload: [{ key: 'errMsg', val: 419 }]
          });
          props.history.push('/error');
        }
      }
    } else {
      dispatchGlobal({
        type: 'UPDATE',
        payload: [
          {
            key: 'customer',
            val: {
              ...globalState.customer,
              isReady: true
            }
          }
        ]
      });
    }
  }
  // render step
  const renderStep = useMemo(() => {
    const step = globalState.customer.currentQrStep;
    switch (step) {
      case '0':
        return;
      case '1':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_3 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '1.1':
        return (
          <>
            <Header />
            <OrderStep_3_mealInfo />
            <Footer />
          </>
        );
      case '2':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_4 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '3':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_5 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '3.1':
        return (
          <>
            <Header />
            <OrderStep_5_verifyEmail />
            <Footer />
          </>
        );
      case 'null':
        return null;
      default:
        throw Error('step page error.');
    }
  }, [globalState.customer.currentQrStep]);

  useEffect(() => {
    handler();
  }, [globalState.customer.isReady, props.location.search]);

  useEffect(() => {
    console.log(globalState.customer.currentQrStep)
    window.document.body.scrollTop = 0;
  }, [globalState.customer.currentQrStep])

  if (!globalState.customer.isReady) {
    return null;
  } else {
    return <div className="Pages">{renderStep}</div>;
  }
}
export default QrTakeOrder;
